<template>
  <div>
    <card class="card-stats vital-card medical-device-card">
      <div class="statistics statistics-horizontal">
        <div class="info info-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="row" style="height: 14em">
                <div class="col-12"
                  v-if="deviceforcard && deviceforcard.icon && (deviceforcard.icon.fileId || deviceforcard.icon.assetName)"
                  style="height: 100%;text-align: center">
                  <dynamic-image v-if="deviceforcard.icon.fileId" :file-id="deviceforcard.icon.fileId"
                    image-style="height: 100%;">
                  </dynamic-image>
                  <img v-else :src="require('@/assets/img/vitals/' + deviceforcard.icon.assetName)"
                    style="height: 100%" />
                </div>
                <div class="col-12">
                  <h5 class="info-title text-left" style="text-align: center !important">
                    {{ deviceforcard.displayName[$i18n.locale] || deviceforcard.displayName['en-US'] }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */

export default {
  props: [
    "deviceforcard",
    "vitalIndex",
    "errorMessages",
    "historicVitals",
    "allowManualEntry",
    "allowRetrieval",
    "hideVitalHistory",
    "disableInputs",
    "shareVitals",
    "shareButton",
    "uploadButton",
  ],

  mounted() {
    //Getting color for chart from settings
    if (
      this.settings &&
      this.settings.theming &&
      this.settings.theming.telemed
    ) {
      let colors = this.settings.theming.telemed;
      colors.primaryColor && (this.color = colors.primaryColor);
    }
  },
};
</script>
<style>
.vital-card {
  border-radius: 2rem;
}

.medical-device-card {
  height: 20em;
}

.vital-image {
  margin-top: 3px;
  margin-left: 3px;
  height: 55px;
  width: 55px;
}

.device-vital-image {
  width: 3em;
  height: 3em;
  margin: 0;
  position: relative;
  top: 0.8em;
}

.el-select .el-input .el-input__inner {
  background-color: transparent;
  border: 1px solid #e3e3e3;
  border-radius: 30px;
  color: black;
}

.has-success:after,
.has-danger:after {
  display: none;
}

.info-horizontal .icon.icon-circle {
  margin-top: 0px;
}

.vital-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(2);
}

.indicator svg polyline {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.indicator svg polyline#back {
  stroke: var(--color-primary) 8c;
}

.indicator svg polyline#front {
  stroke: var(--color-primary);
  stroke-dasharray: 12, 36;
  stroke-dashoffset: 48;
  animation: dash 1s linear infinite;
}

.cta {
  position: fixed;
  bottom: 20px;
  inset-inline-end: 30px;
  color: #222;
  font-weight: bold;
}

@-moz-keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

@-o-keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

#chartjs-tooltip {
  transition: left 0.5s, top 0.5s;
  border-radius: 5px;
}

#chartj-span {
  height: 1em;
  width: 1em;
  display: inline-block;
  border: 1px solid white;
  margin-right: 5px;
  margin-top: 5px;
}
</style>
<style scoped>
.form-control[disabled] {
  background-color: transparent;
  color: #2c2c2c;
}

/deep/ .el-select .el-input .el-input__inner[disabled] {
  background-color: transparent;
}

/deep/ .el-select .el-input .el-input__inner[disabled] {
  background-color: 1px solid #e3e3e3;
}

/deep/ .card-body {
  padding: 15px 15px 15px 15px !important;
}</style>
